export default "__VITE_ASSET__DyHcM4gU__"